import { createApp } from 'vue'
import App from './App.vue'
import "./index.scss"

createApp(App).mount('#app')
